import { parse } from "date-fns";
import { Sex } from "../../../generated/graphql";
import { IValidateError } from "../helpers";

export const isValidID = (id: string): boolean | IValidateError =>
  parseID(id)
    ? true
    : {
        error: "Rodné číslo je neplatné"
      };

export interface IParseID {
  age: number;
  birthday: Date;
  sex: string;
}

export const parseID = (id: string): IParseID | false => {
  const regex = new RegExp(
    "^\\s*(\\d\\d)(\\d\\d)(\\d\\d)[ \\/]*(\\d\\d\\d)(\\d?)\\s*$"
  );
  if (!id) {
    return false;
  }
  try {
    let [, _year, _month, day, ext, c] = id.match(regex);
    let year = parseInt(_year);
    let month = parseInt(_month);

    if (!c) {
      year += year < 54 ? 1900 : 1800;
    } else {
      let mod = Number([_year, _month, day, ext].join("")) % 11;

      if (mod === 10) {
        mod = 0;
      }
      if (mod !== parseInt(c)) {
        return false;
      }
      year += year < 54 ? 2000 : 1900;
    }

    if (month > 70 && year > 2003) {
      month -= 70;
    } else if (month > 50) {
      month -= 50;
    } else if (month > 20 && year > 2003) {
      month -= 20;
    }

    const date = parse([day, month, year].join("."), "dd.MM.yyyy", new Date());
    const diff = Date.now() - date.getTime();
    const ageDate = new Date(diff);
    return {
      age: Math.abs(ageDate.getUTCFullYear() - 1970),
      birthday: date,
      sex: Number(_month.substring(0, 1)) > 1 ? Sex.Female : Sex.Male
    };
  } catch (e) {
    return false;
  }
};
